import React from 'react';
import { Loader, BaasicTable } from 'core/components';
import { defaultTemplate } from 'core/hoc';

const FulfillmentOrdersListTemplate = ({
	viewStore,
	fulfillmentOrdersListViewStore: { loading, listStore, tableData, queryUtility, noDataItem },
	data,
}) => {
	if (loading) return <Loader />;
	return (
		<section className="k-grid__header--sml spc--top--sml">
			<BaasicTable
				{...{
					data,
					tableData,
					queryUtility,
					listStore,
					noDataItem,
					viewStore,
				}}
				actions={viewStore}
			/>
		</section>
	);
};

export default defaultTemplate(FulfillmentOrdersListTemplate);
